// extracted by mini-css-extract-plugin
export default {"TicketRow":"styles_TicketRow__5iXhW","IconCol":"styles_IconCol__8HY3g","DisabledTicketRow":"styles_DisabledTicketRow__Pn8bx"};